import { render, staticRenderFns } from "./ImportAndExport.vue?vue&type=template&id=67b8aa18&"
import script from "./ImportAndExport.vue?vue&type=script&lang=js&"
export * from "./ImportAndExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports